import React, { useEffect, useState } from "react";
import styles from './index.module.css';
import Banner from "../../../components/Home/Banner";
import SearchFilters from "../../../components/SearchFilters";
import { useDispatch, useSelector } from "react-redux";
import { getAllMakes } from "../../../redux/features/make/makeService";
import { selectMakeList } from "../../../redux/features/make/makeSlice";
import { getModel } from "../../../redux/features/model/modelService";
import { selectModelList } from "../../../redux/features/model/modelSlice";
import { getModelCode } from "../../../redux/features/modelCode/modelCodeService";
import { selectModelCodeList } from "../../../redux/features/modelCode/modelCodeSlice";
import { getTransmission } from "../../../redux/features/transmission/transmissionService";
import { selectTransmissionList } from "../../../redux/features/transmission/transmissionSlice";
import { getFuel } from "../../../redux/features/fuel/fuelService";
import { selectFuelList } from "../../../redux/features/fuel/fuelSlice";
import { getVehicleType } from "../../../redux/features/vehicleType/vehicleTypeService";
import { selectVehicleTypeList } from "../../../redux/features/vehicleType/vehicleTypeSlice";
import { getCountry } from "../../../redux/features/country/countryService";
import { getColor } from "../../../redux/features/color/colorService";
import { selectCountryList } from "../../../redux/features/country/countrySlice";
import { selectColorList } from "../../../redux/features/color/colorSlice";
import BrandShowcase from "../../../components/Home/BrandShowcase";
import VehicleTypes from "../../../components/Home/VehicleTypes";
import CarGridHome from "../../../components/Home/CarGridHome";
import { Link } from "react-router-dom";
import { FaPlusCircle } from "react-icons/fa";

const noOfDoors = [];

for (let i = 1; i < 8; i++) {
  noOfDoors.push({ name: i });
}

const noOfSeats = [];

for (let i = 1; i < 60; i++) {
  noOfSeats.push({ name: i });
}

const interiorCond = [
  { id: 'A', name: 'A' },
  { id: 'B', name: 'B' },
  { id: 'C', name: 'C' },
  { id: 'D', name: 'D' },
];
const exteriorCond = [
  { id: 'R', name: 'R' },
  { id: '3.5', name: '3.5' },
  { id: '4', name: '4' },
  { id: '4.5', name: '4.5' },
  { id: '5', name: '5' },
  { id: 'S', name: 'S' },
];

const steering = [{ id: 'RHD', name: 'RHD' }, { id: 'LHD', name: 'LHD' }];

const wheelDrive = [{ id: '2WD', name: '2WD' }, { id: '4WD', name: '4WD' }];

const years = Array.from({ length: 45 }, (v, i) => {
  return { name: i + 1980 };
});

const prices = Array.from({ length: 60 }, (v, i) => {
  return { name: i * 50000 + 50000 };
});

const engineCC = Array.from({ length: 10 }, (v, i) => {
  return { name: i * 500 + 100 };
});

const mileage = Array.from({ length: 10 }, (v, i) => {
  return { name: i * 5000 + 5000 };
});

const Home = () => {

  const dispatch = useDispatch();

  const { status: listLoading, data: makes } = useSelector(selectMakeList);
  const { status: modelsLoading, data: models } = useSelector(selectModelList);
  const { status: modelCodeLoading, data: modelCode } = useSelector(selectModelCodeList);
  const { status: transmissionLoading, data: transmission } = useSelector(selectTransmissionList);
  const { status: fuelLoading, data: fuel } = useSelector(selectFuelList);
  const { status: vehicleTypeLoading, data: vehicleType } = useSelector(selectVehicleTypeList);
  const { status: countryLoading, data: country } = useSelector(selectCountryList);
  const { status: colorLoading, data: color } = useSelector(selectColorList);

  const [listingType, setListingType] = useState("all" | "featured" | "popular")

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getAllMakes({}));
    dispatch(getTransmission({}));
    dispatch(getFuel({}));
    dispatch(getVehicleType({}));
    dispatch(getCountry({}));
    dispatch(getColor({}));
  }, [dispatch]);

  useEffect(() => {
    setListingType("all")
  }, []);


  const handleMakeSelect = (makeId) => {
    dispatch(getModel({ makeId: makeId }));
  };

  const handleModelSelect = (modelId) => {
    dispatch(getModelCode({ modelId: modelId }));
  };
  return (
    <>
      <Banner />
      <div className={`main-container`}>
        <div className={`container-content`}>
          <div className={styles.topDiv}>
            <SearchFilters
              makes={makes}
              models={models}
              onMakeSelect={handleMakeSelect}
              modelCodes={modelCode}
              onModelSelect={handleModelSelect}
              prices={prices}
              years={years}
              transmissions={transmission}
              fuels={fuel}
              vehicleTypes={vehicleType}
              engineCC={engineCC}
              wheelDrives={wheelDrive}
              steerings={steering}
              mileages={mileage}
              countries={country}
              interiorColors={color}
              exteriorColors={color}
              doors={noOfDoors}
              seats={noOfSeats}
              interiorConditions={interiorCond}
              exteriorConditions={exteriorCond}
            />
          </div>
        </div>
      </div>
      {/* <BrandShowcase /> */}
      <div className={`main-container`}>
        <div className={`container-content`}>
          <div className={`layout-wrapper ${styles.mainDiv}`}>
            <div className={styles.categorySelector}>
              <button
                className={listingType == "all" ? styles.active : ""}
                onClick={() => setListingType("all")}
              >
                All Cars
              </button>
              <button
                className={listingType == "featured" ? styles.active : ""}
                onClick={() => setListingType("featured")}
              >
                Featured Cars
              </button>
              <button
                className={listingType == "popular" ? styles.active : ""}
                onClick={() => setListingType("popular")}
              >
                Popular Cars
              </button>
            </div>
            <CarGridHome
              limit={12}
              isFeatured={listingType == "featured" ? true : undefined}
              isPopular={listingType == "popular" ? true : undefined}
              status={true}
            />
            <Link to={"/vehicles"} className={styles.showMore}>
              <span>Show All Cars</span>
              <span className={styles.showMoreIcon}>
                <FaPlusCircle />
              </span>
            </Link>
          </div>
        </div>
      </div>
      <VehicleTypes />
    </>
  )
}

export default Home;